export async function getFavicon(url: string): Promise<string | null> {
  try {
    // Parse the URL to get the origin
    const parsedUrl = new URL(url);
    const origin = parsedUrl.origin;

    // Try different favicon paths in order of preference
    const faviconPaths = [
      // Try Google's favicon service first as it's most reliable
      `https://www.google.com/s2/favicons?domain=${origin}&sz=64`,
      // Fallback to direct favicon paths if needed
      `${origin}/favicon.ico`,
      `${origin}/favicon.png`,
      `${origin}/apple-touch-icon.png`,
      `${origin}/apple-touch-icon-precomposed.png`
    ];

    // Return the Google favicon service URL directly as it's most reliable
    return faviconPaths[0];
  } catch (error) {
    console.error('Error getting favicon:', error);
    return null;
  }
} 